(() => {
  'use strict';
  if (window.TLTServicePages) {
    window.TLTServicePages.init(document);
    return;
  }
  const instances = new Map();
  const rootsIn = (scope) => {
    const roots = [...scope.querySelectorAll('[data-tlt-service]')];
    if (scope.matches?.('[data-tlt-service]')) roots.unshift(scope);
    return roots;
  };
  function init(scope) {
    for (const root of rootsIn(scope)) {
      if (instances.has(root)) continue;
      const dialog = root.querySelector('.tlt-service__dialog');
      if (!dialog) continue;
      const image = dialog.querySelector('.tlt-service__dialog-image');
      const title = dialog.querySelector('h2');
      const close = dialog.querySelector('.tlt-service__dialog-close');
      const controller = new AbortController();
      const options = {signal: controller.signal};
      let trigger = null;
      const finish = () => {
        if (trigger?.isConnected) trigger.focus({preventScroll: true});
        trigger = null;
      };
      root.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-service-image]');
        if (!button || !root.contains(button)) return;
        let url;
        try { url = new URL(button.dataset.serviceImage, document.baseURI); }
        catch { return; }
        // Only URLs rendered by our image-picker/asset filters are used, and
        // only as an image source: no HTML injection or same-origin assumption.
        if (!['https:', 'http:'].includes(url.protocol)) return;
        trigger = button;
        image.src = url.href;
        image.alt = button.dataset.serviceAlt || button.dataset.serviceTitle || '';
        title.textContent = button.dataset.serviceTitle || '';
        if (!dialog.open) dialog.showModal();
        close.focus({preventScroll: true});
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('close', finish, options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, options);
      instances.set(root, {controller, dialog});
    }
  }
  function destroy(scope) {
    for (const root of rootsIn(scope)) {
      const instance = instances.get(root);
      if (!instance) continue;
      if (instance.dialog.open) instance.dialog.close();
      instance.controller.abort();
      instances.delete(root);
    }
  }
  window.TLTServicePages = {init, destroy};
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
